<template>
<v-container app :fluid="true" class="pt-0">
    <v-row>
        <v-col cols="3">
            <v-menu
                v-model="menuFromDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="from_date"
                    label="Desde"
                    readonly
                    solo
                    dense
                    clearable
                    v-on="on"
                    @click:clear="handleClearFrom"
                    hide-details                                    
                    ></v-text-field>
                </template>
                <v-date-picker v-model="from_date" 
                    @input="menuFromDate = false" 
                    no-title
                    locale="es" 
                    @change="handleChangeFormDate">
                </v-date-picker>
            </v-menu>
        </v-col>

        <v-col cols="3">
            <v-menu
                v-model="menuUntilDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="until_date"
                    label="Hasta"
                    readonly
                    solo
                    dense
                    clearable
                    v-on="on"
                    @click:clear="handleClearUntil"
                    hide-details
                    ></v-text-field>
                </template>
                <v-date-picker v-model="until_date" 
                    @input="menuUntilDate = false" 
                    no-title
                    locale="es" 
                    @change="handleChangeUntilDate"
                ></v-date-picker>
            </v-menu>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="12">
            <v-card>
                <v-data-table
                    class="wost-table"
                    :headers="headers"
                    :items="cashes"
                    item-key="id"
                    height="65vh"
                    fixed-header
                >

                    <template v-slot:item.register_date="{item}">
                        <span>{{ item.register_date | moment("DD/MM/YYYY") }}</span>
                    </template>

                    <template v-slot:item.register_hour="{item}">
                        <span>{{ item.register_date | moment("hh:mm a") }}</span>
                    </template>

                    <template v-slot:item.amount_open="{item}">
                        <span>{{ item.amount_open | currency('S/') }}</span>
                    </template>

                    <template v-slot:item.total_amount="{item}">
                        <span>{{ item.total_amount | currency('S/') }}</span>
                    </template>

                    <template v-slot:item.amount_close_cash="{item}">
                        <span>{{ item.amount_close_cash | currency('S/') }}</span>
                    </template>

                    <template v-slot:item.amount_close_cards="{item}">
                        <span>{{ item.amount_close_cards | currency('S/') }}</span>
                    </template>

                    <template v-slot:item.status="{item}">
                        <span v-if="item.status == 'abierta'" :class="'cash-label cash-' + item.status">
                            En uso
                        </span>
                        <span v-else :class="'cash-label cash-' + item.condition">
                            {{ item.condition }}
                        </span>
                    </template>

                    <template v-slot:item.close_date="{item}">
                        <span v-if="item.close_date">{{ item.close_date | moment("DD/MM/YYYY") }}</span>
                    </template>

                    <template v-slot:item.close_hour="{item}">
                        <span v-if="item.close_hour">{{ item.close_hour | moment("hh:mm a") }}</span>
                    </template>

                    <template v-slot:item.action="{item}">
                        <v-btn small outlined color="#3f51b5" 
                            @click="handleViewDetail(item)"
                            v-if="verifyPermission('ver_detalle_historial')">
                            Ver
                        </v-btn>
                    </template>

                </v-data-table>
                
            </v-card>
        </v-col>
    </v-row>
    <detail-history ref="detailHistory"></detail-history>
</v-container>
    
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import ApiReports from '../../apis/Reports'

import DetailHistory from '../../components/Cashflow/DetailHistory'

export default {
    name: 'HistoryCash',
    components: {
        DetailHistory
    },
    data() {
        return {
            cashes: [],
            menuFromDate: false,
            from_date: null,
            menuUntilDate: false,
            until_date: null,
            headers: [
                { text: 'FECHA', value: 'register_date', align: 'left', sortable: false, class: 'header-table'},
                { text: 'HORA', value: 'register_hour', align: 'left', sortable: false, class: 'header-table'},
                { text: 'MONTO APERTURA', value: 'amount_open', align: 'end', sortable: false, class: 'header-table'},
                { text: 'TOTAL', value: 'total_amount', align: 'end', sortable: false, class: 'header-table'},
                { text: 'MONTO CIERRE EFECTIVO', value: 'amount_close_cash', align: 'end', sortable: false, class: 'header-table'},
                { text: 'MONTO CIERRE TARJETA', value: 'amount_close_cards', align: 'end', sortable: false, class: 'header-table'},
                { text: 'ESTADO', value: 'status', align: 'left', sortable: false, class: 'header-table'},
                { text: 'FECHA CIERRE', value: 'close_date', align: 'left', sortable: false, class: 'header-table'},
                { text: 'HORA CIERRE', value: 'close_hour', align: 'left', sortable: false, class: 'header-table'},
                { text: '', value: 'action', align: 'end', sortable: false }
            ]
        }
    },
    computed: {
        ...mapState('cash', [
            'cashSelected'
        ])
    },
    methods: {
        ...mapActions('cash', [
            'runSetDateFilter',
            'selectCash',
            'getIncomes'
        ]),
        getCashes(){
            let params = {
                from: this.from_date,
                until: this.until_date
            }
            ApiReports.cash(params)
                    .then(({data}) => {
                        this.cashes = data
                    })
        },
        handleClearFrom(){
            this.from_date = null
            this.getCashes()
        },
        handleClearUntil(){
            this.until_date = null
            this.getCashes()
        },
        handleChangeFormDate(){
            this.getCashes()
        },
        handleChangeUntilDate(){
            this.getCashes()
        },
        async handleViewDetail(itemCash) {
            let dateParam = this.prepareDate(new Date(itemCash.register_date))
            this.runSetDateFilter(dateParam)
            this.selectCash(itemCash);
            await this.getIncomes(this.cashSelected.id);
            this.$refs.detailHistory.showForm(itemCash.id, dateParam)
        },
        prepareDate(dataDate) {
            let year = dataDate.getFullYear()
            let month = dataDate.getMonth() + 1
            let day = dataDate.getDate()

            if (month < 10) {
                month = '0' + month.toString()
            }

            if (day < 10) {
                day = '0' + day.toString()
            }

            let dateValue = year + '-' + month + '-' + day
            return dateValue
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    },
    mounted() {
        this.getCashes()
    }
}
</script>

<style>
.cash-label{
    display: inline-block;
    width: 100px;
    text-align: center;
    border-radius: 6px;
    font-size: 12px;
    text-transform: uppercase;
}

.cash-abierta{
    border: 1px solid #1E88E5;
    background-color: #1E88E5;
    color: white;
}

.cash-sobrante{
    border: 1px solid #FFB300;
    background-color: #FFB300;
    color: white;
}

.cash-cuadre{
    border: 1px solid #43A047;
    background-color: #43A047;
    color: white;
}

.cash-faltante{
    border: 1px solid #E53935;
    background-color: #E53935;
    color: white;
}
</style>